<template>
  <div class="student-card">
    <div class="avatar-section">
      <img :src="student.avatar" class="avatar" alt="头像" />
      <div class="tag" :style="{ background: student.tagColor }">{{ student.tag }}</div>
    </div>
    <div class="info-section">
      <div class="name-gender-row">
        <span class="name">{{ student.name }}</span>
        <span class="gender">{{ student.gender }}</span>
      </div>
      <div class="school">{{ student.school }}</div>
      <div class="direction">专业方向：{{ student.direction }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StudentCard',
  props: {
    student: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.student-card {
  display: flex;
  align-items: flex-start;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 8px 0 rgba(36,102,246,0.03), 0 1.5px 4px 0 rgba(0,0,0,0.02);
  margin: 0 12px 18px 12px;
  padding: 18px 18px 12px 16px;
  position: relative;
  min-height: 72px;
  transition: box-shadow 0.2s;
  &:hover {
    box-shadow: 0 4px 16px 0 rgba(36,102,246,0.08), 0 2px 8px 0 rgba(0,0,0,0.04);
  }
}
.avatar-section {
  position: relative;
  width: 54px;
  height: 54px;
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
}
.avatar {
  width: 54px;
  height: 54px;
  border-radius: 10px;
  object-fit: cover;
  background: #f0f0f0;
  border: 1px solid #eaeaea;
}
.tag {
  position: absolute;
  top: -8px;
  left: -8px;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  border-radius: 10px;
  padding: 2px 12px;
  box-shadow: 0 2px 8px 0 rgba(0,0,0,0.04);
  letter-spacing: 1px;
  z-index: 2;
}
.info-section {
  flex: 1;
  margin-left: 14px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  height: 54px;
}
.name-gender-row {
  display: flex;
  align-items: flex-start;
  font-size: 16px;
  font-weight: 700;
  color: #222;
  margin-bottom: 4px;
  gap: 7px;
}
.name {
  font-size: 16px;
  font-weight: 700;
  color: #222;
}
.gender {
  font-size: 15px;
  color: #888;
  font-weight: 500;
}
.school {
  font-size: 14px;
  color: #555;
  margin-bottom: 2px;
  text-align: left;
}
.direction {
  font-size: 13px;
  color: #888;
  text-align: left;
}
</style> 